import { UIOfferPerk } from 'interfaces/ui/ui-offer-perk';
import Image from 'next/image';
import { config } from 'utils/config';
import {
  StyledOfferPerksItem,
  StyledOfferPerksItemDesc,
  StyledOfferPerksItemIcon,
  StyledOfferPerksItemTitle
} from './OfferPerksItem.styled';

type OfferPerksItemType = {
  perksItem: UIOfferPerk | void;
};

const OfferPerksItem: React.FC<OfferPerksItemType> = ({ perksItem }) => (
  <>
    {perksItem && (
      <StyledOfferPerksItem>
        <StyledOfferPerksItemIcon>
          {perksItem.icon && (
            <Image
              width={48}
              height={48}
              layout="fixed"
              src={perksItem.icon}
              alt=""
            />
          )}

          {!perksItem.icon && (
            <Image
              width={48}
              height={48}
              layout="fixed"
              src={config.defaultPerkIcon}
              alt=""
            />
          )}
        </StyledOfferPerksItemIcon>
        <div>
          <StyledOfferPerksItemTitle>
            {perksItem.perk}
          </StyledOfferPerksItemTitle>
          {perksItem.desc && (
            <StyledOfferPerksItemDesc>
              {perksItem.desc}
            </StyledOfferPerksItemDesc>
          )}
        </div>
      </StyledOfferPerksItem>
    )}
  </>
);

export default OfferPerksItem;
